<template>
  <div class="row stacked-srp-prices text-right">
    <div class="col-xs-12">
      <div class="row stacked-vehicle-prices">
        <div class="col-xs-12 highest-price double-stacked-price">
          <h3 class="">${{ numberFormatter(price.market) }}</h3>
          <h5 class="price-label">MSRP</h5>
        </div>
        <template v-if="isLocked">
          <div class="col-xs-12 asking-price lowest-price">
            <h3 class="">$XX,XXXX</h3>
            <h5 class="price-label">Locked Price</h5>
          </div>
        </template>
        <template v-else>
          <div class="col-xs-12 price-savings">
            <h4>${{ numberFormatter(price.market - price.belowMarket) }}</h4>
            <h5 class="price-label">Savings</h5>
          </div>
          <div class="col-xs-12 asking-price lowest-price">
            <h3 class="">${{ numberFormatter(price.belowMarket) }}</h3>
            <h5 class="price-label">Our Price</h5>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { numberWithCommas } from "@/helpers";

export default {
  name: "RowVehiclePricing",
  props: {
    isLocked: {
      type: Boolean,
      required: true,
    },
    price: {
      type: Object,
      required: true,
    },
  },
  methods: {
    numberFormatter(num) {
      return numberWithCommas(num);
    },
  },
};
</script>

<style
  scoped
  src="../../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
></style>

<style scoped>
.vehicle-unit {
  background: #fff;
  padding: 10px 0px;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.2);
  margin: 0 0 10px 0;
}

.srp-window-sticker-link i {
  font-size: 20px;
  color: green;
}

.srp-window-sticker-link span {
  font-weight: 400;
}

.vehicle-index-summary {
  padding-bottom: 10px;
  padding-top: 10px;
}

.vehicle-index-page {
  background: #f0f0f0;
}

.vehicle-index-container {
  max-width: 1440px;
  margin: auto;
}

.listing-page {
  padding-top: 15px;
  margin: 0 auto;
}

.vdp-link {
  font-weight: 300;
  font-size: 14px;
  color: #5b616b;
}

.vehicle-thumb img {
  width: 100%;
}

.vehicle-index-summary .pull-right {
  font-weight: 300;
}

.stacked-srp-prices h3,
.stacked-srp-prices h4 {
  margin: 0 0 5px;
}

.stacked-srp-prices h5 {
  margin: 0 0 10px;
  font-size: 12px;
}

.stacked-srp-prices .vauto-incentives h4 {
  font-size: 16px;
}

.stacked-srp-prices .single-stacked-price {
  margin-top: 37px;
}

.stacked-srp-prices .double-stacked-price {
  margin-top: 15px;
}

.stacked-srp-prices .price-savings {
  color: green;
}
.stacked-srp-prices .price-savings h5 {
  padding-bottom: 5px;
  border-bottom: 1px solid;
}

.stacked-srp-prices .price-total-savings {
  color: green;
}
.stacked-srp-prices .price-total-savings h4 {
  font-size: 1.7em;
}
.stacked-srp-prices .price-total-savings h5 {
  padding-bottom: 5px;
  border-bottom: none;
}

.vehicle-specs {
  font-size: 14px;
  font-weight: bold;
}
.vehicle-specs h2 {
  font-size: 20px;
  padding-bottom: 10px;
}

.sticky-bottom-content {
  position: fixed;
  bottom: 0;
  width: 100%;
  background: white;
  padding: 10px;
  z-index: 99;
  border-top: 1px solid black;
}

.text-toggle {
  display: inline-block;
  background-color: #a5a5a5;
  color: white;
  padding: 3px 5px;
  border-radius: 5px;
}
.text-toggle:hover {
  cursor: pointer;
}

@media only screen and (min-width: 768px) {
  .vehicle-index-price {
    padding-top: 90px;
  }
  .index-button-padding {
    padding: 0;
  }
}

@media only screen and (max-width: 768px) {
  .vehicle-unit {
    padding-bottom: 10px;
  }
  .car-srch-box {
    padding-left: 30px;
    padding-right: 30px;
  }
}

@media only screen and (min-width: 768px) and (max-width: 992px) {
  .spects .bottom_link a {
    padding: 10px;
    font-size: 14px;
  }
  .page-filter .glyphicon-th-list {
    margin-right: 10px;
  }
  .filter-form {
    padding-right: 0;
  }
}

@media only screen and (max-width: 768px) {
  .index-button-left {
    padding-right: 0;
  }
  .index-button-right {
    padding-left: 0;
  }
  .search-list .vehicle-index-price {
    margin-bottom: 0;
    padding-bottom: 0;
  }
  .search-list .vehicle-index-price h3 {
    font-size: 15px;
  }
  .right-button-cont {
    padding: 25px 0 0 0;
  }
  .filter-form {
    padding-right: 0;
  }
  .spects .bottom_link a {
    margin-bottom: 10px;
  }
  .small_p {
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .col-sm-4.car-box {
    margin-bottom: 20px;
    background: #fff;
  }
  .filter-form {
    padding-right: 0;
  }
  .Banner .item img {
    min-height: auto !important;
  }
  .FooterBlack .left_footer_text {
    text-align: center;
    width: 100%;
    display: inline-block;
  }
  .FeaturedCarData {
    text-align: center;
  }
}

@media only screen and (max-width: 1024px) {
  .available-rebates-btn {
    font-size: 12px;
  }
}

.eprice-button {
  padding: 11px 14px;
  font-size: 13px;
  font-weight: bold;
  width: 100%;
  text-align: center;
  display: inline-block;
  margin-top: 5px;
  background-color: red;
}

.vehicle-buttons {
  padding-top: 10px;
  text-align: center;
  margin: 0 auto;
}
.vehicle-buttons .btn {
  width: 100%;
  margin: 5px auto;
  font-weight: bold;
  padding: 11px 14px;
}
.vehicle-buttons .price-alert-button {
  width: 100%;
  margin-top: 5px;
  margin-bottom: 5px;
  font-weight: bold;
  font-size: 13px;
  padding: 11px 14px;
}
.vehicle-buttons .get-more-info-button {
  width: 100%;
  margin-top: 5px;
  margin-bottom: 5px;
  font-weight: bold;
  font-size: 13px;
  padding: 11px 14px;
}

.vehicle-action-buttons .price-alert-button {
  margin-top: 5px;
}

.find-my-car-button {
  color: #000;
  font-weight: bold;
  font-size: 2em;
}

.inventory-type-button-block {
  margin-bottom: 1.4em;
  width: 100%;
  font-weight: bold;
  font-size: 1.7em;
}

.inventory-type-button-block.active {
  color: #000;
}

.get-price-button,
.unlock-price-button {
  width: 100px;
  max-width: 100%;
  cursor: pointer;
}

.get-price-button:focus,
.unlock-price-button:focus {
  outline: 5px auto -webkit-focus-ring-color;
  outline-offset: -2px;
}

.btn.launch-vehicle-video-modal {
  margin-bottom: 10px;
}

.add-vehicle-wishlist {
  position: absolute;
  left: 0.2em;
  top: 0.2em;
  cursor: pointer;
  color: #ea524b;
  z-index: 100;
}

.add-vehicle-wishlist-relative {
  position: relative;
  left: 0.2em;
  top: 1.2em;
  cursor: pointer;
  color: #ea524b;
  z-index: 100;
}

.vehicle-filter-home-buttons .btn {
  width: 100%;
  color: #d92027;
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 0;
  font: 600 20px/30px "Open Sans", sans-serif;
  text-transform: none;
  text-indent: 0;
  border: 2px solid #d92027;
  -ms-touch-action: manipulation;
  touch-action: manipulation;
  cursor: pointer;
  opacity: 1;
  margin-bottom: 10px;
}
.vehicle-filter-home-buttons .btn:hover {
  background: rgba(217, 32, 39, 0.8);
  color: #fff;
  border: 2px solid #fff;
}
.vehicle-details {
  margin-top: -20px;
}
.btn {
  color: #fff;
  font-size: 1rem;
}
.btn-1 {
  background: #d92027;
}
.btn-2 {
  background: #ff6634;
}
.btn-3 {
  background: #a0b800;
}
.btn-4 {
  background: #3776b2;
}
</style>